import { render } from "./PropertyCard.vue?vue&type=template&id=38e7b944&scoped=true"
import script from "./PropertyCard.vue?vue&type=script&lang=js"
export * from "./PropertyCard.vue?vue&type=script&lang=js"

import "./PropertyCard.vue?vue&type=style&index=0&id=38e7b944&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e7b944"]])

export default __exports__